
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Grid, Modal, Stack } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageTitle from "../commoncomponents/PageTitle";
import PageLoader from "../commoncomponents/PageLoader";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import { getAuthToken, getcompanyId, getFacilityId, getuserId } from "../../utility/tokenUtility";
import { MasterGraph, BemsGraph, FemsGraph, ifacSecurityURL } from "../../utility/apiURLS";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import Stockdownloadfile from "./Stockdownloadfile";
import utilities from "../../utility/utilities";
import commonMessages from "../../utility/constant";
import { useAccess } from "../../AccessContext";
const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1200px",
    height: "100%",
    maxHeight: "calc(100% - 64px)",
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
    overflowY: "auto",
    overflowX: "hidden",
};

const Stockviewfile = () => {
    const [gridApi, setGridApi] = useState(null);
    const [mergedMap, setMergedMap] = useState(new Map()); // Define mergedMap state
    const [hospitalOptions, setHospitalOptions] = useState([]); // Define hospitalOptions state
    const [processedData, setProcessedData] = useState([]); // Define state for processed data

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "STRA001");
    const [isDisabled, setIsDisabled] = useState(false);
    const [service, setService] = useState("");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [errorMessages, setErrorMessages] = useState({});
    const [errors, setErrors] = useState({});
    const [hospitalnameOptions, setHospitalnameOptions] = useState([]);
    const [hospitalname, setHospitalname] = useState("");
    const [reportdata, setReportdata] = useState([]);
    const childRef = useRef(null);
    const [openModal, setOpenModal] = useState(false);
    const [enableDownload, setEnableDownload] = useState(false);
    const [isView, setIsView] = useState(false);
    const [loading, setLoading] = useState(false);

    const [names, setName] = useState("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const token = getAuthToken("id_token");
    const userId = getuserId("userId");
    const companyId = getcompanyId("companyId");
    const facilityId = getFacilityId("facilityId");
    const filteredOptions = service === 'FEMS'
        ? [{ label: 'FEMS', value: 'fem', id: 'fem' }]
        : service === 'BEMS'
            ? [{ label: 'BEMS', value: 'bem', id: 'bem' }]
            : [];

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        fetchServiceOptions();
        fetchHospitalName();
    }, []);


    const fetchServiceOptions = async () => {
        try {
            const response = await axios.get(`${MasterGraph}/api/masservicedetails`, config);
            const options = response.data.map((option) => ({
                label: option.service,
                value: option.service,
                id: option.id,
            }));
            setServiceOptions(options);

        } catch (error) {
            console.error("Failed to fetch service options:", error);
        }
    };


    const fetchHospitalName = async () => {
        try {
            const response = await axios.get(
                `${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`,
                config
            );
            if (response.data && Array.isArray(response.data)) {
                const options = response.data.map((hn) => ({
                    label: hn.facilityName,
                    id: hn.facilityId,
                }));
                setHospitalnameOptions(options);

                setName(response.data)

            }
        } catch (error) {
            console.error("Error fetching hospital names:", error);
        }
    };

    const handleServiceChange = (newValue) => {
        setService(newValue?.value || "");
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, service: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "Service is required" }));
        }
    };
    const handlehospitalChange = (newValue) => {
        setHospitalname(newValue);
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, hospitalname: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalname: "" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, hospitalname: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, hospitalname: "Hospital Name is required" }));
        }
    };


    const handleGetResultClick = async () => {
        if (!service || !hospitalname) {
            setErrors({
                service: !service,
                hospitalname: !hospitalname,
            });
            setErrorMessages({
                service: !service ? "Service is required" : "",
                hospitalname: !hospitalname ? "Hospital Name is required" : "",
            });
            return;
        }

        setLoading(true);
        setIsDisabled(true);
        const selectedService = filteredOptions.length > 0 ? filteredOptions[0].id : "";

        try {
            const response = await axios.get(`${MasterGraph}/api/StockReport/GetStockRegisterReport/${hospitalname.id}/${selectedService}?size=1000`, config);

            setReportdata(
                response.data.map((item) => ({
                    ...item,
                    hospitalname: hospitalnameOptions.find((option) => item.facilityid === option.id)?.label || "",
                    uom: item.masimsstockregisters?.[0]?.remarks || "", // Extracting the UOM field from the first object in masimsstockregisters
                    stockBalance: item.masimsstockregisters?.[0]?.currentstocklevel || "", // Extracting the stock level field from the first object in masimsstockregisters
                }))
            );

            setEnableDownload(response.data.length > 0);

        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleViewButtonClick = () => {
        setIsView(true);
        setOpenModal(true);

    };


    const handleDownloadPDF = async () => {
        setIsView(false);
        setOpenModal(true);


        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleDownloadPDF();
            }
            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);
    };
    const handleRefreshClick = () => {
        setHospitalname("");
        setService("");
        setReportdata([]);
        setErrors({});
        setErrorMessages({});
        setEnableDownload(false);
        setIsView(false);
        setIsDisabled(false); 
        utilities.refreshGrid(gridApi);
    };
    const handleClose = () => {
        navigate("/dashboard");
        dispatch(setSelectedIndex("SET_INDEX_LABEL", ""));
        dispatch(setHeaderName("SET_HEADER_NAME", "Dashboard"));
    };




    const mapName = (id) => {

        const name = names.find(emp => emp?.facilityId === id);

        return name ? name?.facilityName : '';
    };

    return (
        <>
            <PageLoader open={loading} />
            <PageTitle title="Stock Analysis Report" />
            <DefaultCard>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            label="Hospital Name"
                            id="hospital-name"
                            autoFocus
                            value={hospitalname}

                            data-testid="hospital-name"
                            options={hospitalnameOptions}
                            onChange={handlehospitalChange}
                            isMandatoryField
                            error={errors.hospitalname}
                            errorMessage={errorMessages.hospitalname}
                            disabled={isDisabled}
                        />
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <CustomSelectInput
                            id="service-label"
                            label="Service"
                            value={serviceOptions.find((option) => option.value === service) || null}
                            options={serviceOptions}
                            onChange={handleServiceChange}
                            isMandatoryField
                            error={errors.service}
                            errorMessage={errorMessages.service}
                            disabled={isDisabled}
                        />
                    </Grid>
                </Grid>

                <Stack direction="row" justifyContent="end" spacing={2}>
                    <Button variant="contained" onClick={handleGetResultClick} disabled={isDisabled} data-testid="getresult">
                        Get Result
                    </Button>
                    <Button variant="outlined" onClick={handleRefreshClick} data-testid="refresh-button">
                        Refresh
                    </Button>
                </Stack>
            </DefaultCard>

            <DefaultCard mt={2}>
                <Stack mb={1} direction="row" justifyContent="end">
                    <RefreshExportButtons
                        exportFunction={() => { }}
                        exportData={reportdata.map(item => ({
                            ...item,

                            hospitalname: mapName(item?.facilityid) || "",
                        })) || []}
                        handleRefresh={handleGetResultClick}
                        refData={gridApi}
                        reportdata={reportdata}
                        setGridApi={setGridApi}
                        title="Stock Report"
                        customPdf={handleDownloadPDF}
                    />
                </Stack>
                <CustomAgGrid
    rows={reportdata.map(item => ({
        ...item,
        hospitalname: mapName(item?.facilityid) || "",
    })) || []}
    columns={[
        { field: "hospitalname", headerName: "Hospital Name", minWidth: 300 },
        { field: "itemcode", headerName: "Item Code", minWidth: 300 },
        { field: "itemDescription", headerName: "Item Description", minWidth: 150 },
        {
            field: "uom", // Flat field created from masimsstockregisters[0].remarks
            headerName: "UOM",
            minWidth: 300,
        },
        { field: "itemType", headerName: "Item Type", minWidth: 300 },
        {
            field: "minimumstock",
            headerName: "Minimum",
            minWidth: 200,
            cellStyle: { textAlign: "right" }, // Align text to the right
        },
        {
            field: "maximumstock",
            headerName: "Maximum",
            minWidth: 300,
            cellStyle: { textAlign: "right" }, // Align text to the right
        },
        {
            field: "stockBalance", // Flat field created from masimsstockregisters[0].currentstocklevel
            headerName: "Stock Balance",
            minWidth: 300,
            cellStyle: { textAlign: "right" }, // Align text to the right
        },
    ]}
    ref={gridApi}
    setGridApi={setGridApi}
    isLoading={loading}
/>




                <Stack
                    direction="row"
                    justifyContent="end"
                    alignItems="center"
                    gap={2}
                    mt={2}
                >
                    <Button
                        variant="contained"
                        disabled={!enableDownload}
                        onClick={handleViewButtonClick}
                        data-testid="view-button"
                    >
                        View
                    </Button>
                    {access?.canPrint
                        && <Button
                            variant="contained"
                            disabled={!enableDownload}
                            onClick={handleDownloadPDF}
                            data-testid="download-button"
                        >
                            Download
                        </Button>}
                    <Button variant="outlined" onClick={handleClose} data-testid="back-button">
                        Back
                    </Button>
                </Stack>
            </DefaultCard>

            <Modal
                open={openModal}
                sx={
                    !isView && {
                        "& .MuiBackdrop-root": {
                            backgroundColor: "transparent",
                        },
                        top: "-9999px",
                        left: "-9999px",
                        zIndex: "-1",
                    }
                }
            >

                <Box sx={ModalStyle}>
                    <Stockdownloadfile
                        ref={childRef}
                        reportdata={reportdata}
                        hospitalname={hospitalname}
                        service={service}
                        setOpenModal={setOpenModal}
                        setIsView={setIsView}
                    />
                </Box>



            </Modal>
        </>
    );
};

export default Stockviewfile;
